<template>
  <div class="container-fluid">
    <div class="row tick-row">
      <main id="main" class="site-main main-content">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row tick-cont">
                  <div class="col-md-12 submit-form">
                    <div class="form-title">
                      <h1
                        class="logo"
                        style="margin: 0 auto; text-align: center;display: flex;"
                      >
                        <a
                          href="https://www.clearmeout.com/"
                          style="
                            display: block;
                            width: fit-content;
                            margin: auto;
                          "
                        >
                          <img
                            class="img-responsive"
                            src="/static/assets/images/logo.png"
                            alt="ClearMeOut"
                          />
                        </a>
                      </h1>
                      <h3 style="text-align: center;">Payments</h3>
                      <br />
                    </div>
                    <div class="something"></div>
                    <form class="wpcf7-form">
                      <input
                        type="hidden"
                        name="secret_key"
                        value="e2cd60ee-3946-4c63-816f-f2ef087c0171"
                      />
                      <input
                        type="hidden"
                        name="cms"
                        value="PHP"
                      />
                      <input
                        type="hidden"
                        name="custom_fields"
                        value=""
                      />
                      <input
                        type="hidden"
                        name="payment"
                        :v-bind:value="paymentCalculated"
                      />
                      <div class="form-group">
                        <label for="exampleInputFN1">First Name*</label>
                        <input
                          type="text"
                          v-model="firstName"
                          name="first_name"
                          class="form-control"
                          id="exampleInputFN1"
                          aria-describedby="fullNameHelp"
                          placeholder="Enter first name"
                          required=""
                          maxlength="30"
                        />
                        <small
                          id="fullNameHelp"
                          class="form-text text-muted"
                          v-if="fullNameRequiredError"
                          >First Name is Required</small
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputFN1">Last Name*</label>
                        <input
                          type="text"
                          v-model="lastName"
                          name="last_name"
                          class="form-control"
                          id="exampleInputFN1"
                          aria-describedby="lastNameHelp"
                          placeholder="Enter last name"
                          required=""
                          maxlength="30"
                        />
                        <small
                          id="lastNameHelp"
                          class="form-text text-muted"
                          v-if="fullNameRequiredError"
                          >Last Name is Required</small
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Email Address*</label>
                        <input
                          type="email"
                          v-model="email"
                          name="email"
                          class="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Enter email"
                          required=""
                        />
                        <small
                          id="emailHelp"
                          class="form-text text-muted"
                          v-if="emailRequiredError"
                          >Your Email is Required</small
                        >
                        <small
                          id="emailHelp"
                          class="form-text text-muted"
                          v-if="emailError"
                          >Invalid Email address format</small
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPhoneil1">Phone*</label>
                        <input
                          type="text"
                          name="contact_number"
                          v-model="contact_number"
                          class="form-control"
                          id="exampleInputPhoneil1"
                          aria-describedby="phonelHelp"
                          placeholder="Enter phone"
                          required=""
                          maxlength="15"
                        />
                        <small
                          id="phonelHelp"
                          class="form-text text-muted"
                          v-if="emailRequiredError"
                          >Your Phone is Required</small
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPhoneil1">Address*</label>
                        <input
                          type="text"
                          name="address_line_one"
                          v-model="address_line_one"
                          class="form-control"
                          placeholder="Enter address"
                          required=""
                        />
                        <small
                          class="form-text text-muted"
                          v-if="emailRequiredError"
                          >Your Address is Required</small
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPhoneil1">City*</label>
                        <input
                          type="text"
                          name="city"
                          v-model="city"
                          class="form-control"
                          placeholder="Enter address"
                          required=""
                        />
                        <small
                          class="form-text text-muted"
                          v-if="emailRequiredError"
                          >Your Address is Required</small
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPhoneil1">Postal Code*</label>
                        <input
                          type="text"
                          name="postal_code"
                          v-model="postal_code"
                          class="form-control"
                          placeholder="Enter address"
                          required=""
                        />
                        <small
                          class="form-text text-muted"
                          v-if="emailRequiredError"
                          >Your Address is Required</small
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPhoneil1">Country*</label>
                        <div
                          style="flex: 1 1 0%;flex-direction: row;justify-content: space-between;display: flex;border: 1px solid rgb(198 202 206);padding: 10px 0px;border-radius: 10px;outline: none;"
                        >
                          <vue-country-code
                            @onSelect="onSelectCountry"
                            :preferredCountries="['us', 'gb']"
                            :dropdownOptions="{ disabledDialCode: true }"
                            style="border: 0"
                          ></vue-country-code>
                          <input
                            type="text"
                            name="country"
                            v-model="country"
                            class="form-control"
                            id="exampleInputPhoneil1"
                            aria-describedby="phonelHelp"
                            placeholder="Enter address"
                            required=""
                            value="Sri Lanka"
                            readonly
                            style="
                              border: 0;
                              outline: none;
                              background: transparent;
                              padding: 0;
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <!-- <label for="exampleInputAmount1">Order ID*</label> -->
                        <input
                          type="hidden"
                          class="form-control"
                          id="exampleInputAmount1"
                          aria-describedby="amountHelp"
                          placeholder="Enter amount"
                          required=""
                          readonly
                          v-model="orderId"
                        />
                        <small
                          id="amountHelp"
                          class="form-text text-muted"
                          v-if="emailRequiredError"
                          >Order ID is Required</small
                        >
                      </div>
                      <div class="form-group">
                        <!-- <label for="exampleInputAmount1">Item</label> -->
                        <input
                          type="hidden"
                          value="Custom Package"
                          class="form-control"
                          id="exampleInputAmount1"
                          aria-describedby="amountHelp"
                          placeholder="Enter package"
                          required=""
                          readonly
                        />
                        <small
                          id="amountHelp"
                          class="form-text text-muted"
                          v-if="emailRequiredError"
                          >Item is Required</small
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputAmount1">Amount*</label>
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputAmount1"
                          aria-describedby="amountHelp"
                          placeholder="Enter amount"
                          required=""
                          v-model="amount"
                        />
                        <small
                          id="amountHelp"
                          class="form-text text-muted"
                          v-if="emailRequiredError"
                          >Amount is Required</small
                        >
                      </div>
                      <div class="form-group">
                        <!-- <label for="exampleInputCurrency1">Currency*</label> -->
                        <input
                          type="hidden"
                          name="process_currency"
                          class="form-control"
                          id="exampleInputCurrency1"
                          aria-describedby="amountHelp"
                          placeholder="Enter currency"
                          required=""
                          value="USD"
                          readonly
                        />
                        <small
                          id="amountHelp"
                          class="form-text text-muted"
                          v-if="emailRequiredError"
                          >Currency is Required</small
                        >
                      </div>
                      <div>
                        <span
                          style="color: #d63e3e; font-weight: 600"
                          id="ticket"
                        ></span>
                      </div>

                      <button type="button" v-on:click="submit" class="btn btn-primary check-btn" style="margin: 0 auto;display: block;">
                        Next
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
      </main>
    </div>
  </div>
</template>

<script>

const NodeRSA = require('node-rsa');

export default {
  name: "support_track",
  computed: {
    paymentCalculated: function() {
      const key = new NodeRSA('-----BEGIN PUBLIC KEY-----\n'+
'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDEhlwyTzk7SwWt3FoUmoO/pizF\n'+
'K1I3YbWY9jJ9p/EyHXqry/6z4bd/GyqV69Naul4t1fyK4kncY8+K1M/D0WMARThW\n'+
'xEhEiXEHG5khhoLYo0ZAk3BbJSGMO64vbnf4eT3lr0YK5v+nJ1My2rAAO9c5HL8S\n'+
'AjglEJ0VZ+JYOsripwIDAQAB\n'+
'-----END PUBLIC KEY-----');
      const min = 11111111111;
      const max = 99999999999;
      const rand = parseInt(min + Math.random() * (max - min));

      let price = this.amount;
      let order_id = rand;
      let text = order_id + '|' + price;
      const encrypted = key.encrypt(text, 'base64');

      this.encryptedPayment = encrypted;

      return encrypted;
    }
  },
  data() {
    return {
      msg: "Clear Me Out - Support",
      encryptedPayment: "",
      email: "",
      ticketNumber: "",
      firstName: "",
      lastName: "",
      emailRequiredError: false,
      ticketNumberRequiredError: false,
      emailError: false,
      fullNameRequiredError: false,
      address_line_one: "",
      contact_number: "",
      postal_code: "",
      city: "",
      country: "Sri Lanka",
      orderId: `${Math.random() * 999999}`,
      amount: null,
    };
  },
  methods: {
    onSelectCountry: function (d) {
      console.log("onSelectCountry:e", d);
      this.country = d.name;
    },
    submit: function (e) {
      jQuery('.something').append('<form action="https://webxpay.com/index.php?route=checkout/billing" name="vote" id="vote" method="post" style="display:none;">' +
                '<input type="text" name="first_name" value="' + this.firstName + '" />' +
                '<input type="text" name="last_name" value="' + this.lastName + '" />' +
                '<input type="text" name="email" value="' + this.email + '" />' +
                '<input type="text" name="contact_number" value="' + this.contact_number + '" />' +
                '<input type="text" name="address_line_one" value="' + this.address_line_one + '" />' +
                '<input type="text" name="postal_code" value="' + this.postal_code + '" />' +
                '<input type="text" name="country" value="' + this.country + '" />' +
                '<input type="text" name="city" value="' + this.city + '" />' +
                '<input type="text" name="process_currency" value="' + 'USD' + '" />' +
                '<input type="text" name="secret_key" value="e2cd60ee-3946-4c63-816f-f2ef087c0171" />' +
                '<input type="text" name="custom_fields" value="" />' +
                '<input type="text" name="cms" value="PHP" />' +
                '<input type="text" name="payment" value="' + this.encryptedPayment + '" />' +
                '</form>');
            document.getElementById("vote").submit();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.entry-content form .check-btn{
    padding: 9px 45px;
    margin-top: 7px;
    outline: none;
    background-color: #6773DD;
    font-size: 16px;
    font-weight: 700;
    transition: 0.3s ease-in-out;
    border: 0 none;
    font-weight: bold;
    padding: 15px 28px;
    color: #fff;
    line-height: 1;
    border-radius: 10px;
    transition: all 250ms ease;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/payment.vue